(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlight-premium"] && !Shopify.designMode) return;
  try {
    
  class ProductHighlightScrollZoom {
    constructor() {
      this.elements = document.querySelectorAll('[data-scroll-zoom]');
      if (this.elements.length === 0) return;

      this.maxScale = 1.15; // Maximum scale (15% larger)
      this.minScale = 1;    // Starting scale

      this.init();
    }

    init() {
      // Use Intersection Observer for performance
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.addScrollListener(entry.target);
            } else {
              this.removeScrollListener(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '100px' }
      );

      this.elements.forEach((el) => {
        el._scrollHandler = this.handleScroll.bind(this, el);
        this.observer.observe(el);
      });
    }

    addScrollListener(element) {
      window.addEventListener('scroll', element._scrollHandler, { passive: true });
      this.handleScroll(element); // Initial calculation
    }

    removeScrollListener(element) {
      window.removeEventListener('scroll', element._scrollHandler);
    }

    handleScroll(element) {
      const section = element.closest('.product-highlight-premium');
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate progress: 0 when section enters viewport, 1 when section center is at viewport center
      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = windowHeight / 2;

      // Progress from 0 to 1 as section scrolls into view
      const distanceFromCenter = Math.abs(sectionCenter - viewportCenter);
      const maxDistance = windowHeight / 2 + rect.height / 2;
      const progress = 1 - Math.min(distanceFromCenter / maxDistance, 1);

      // Calculate scale based on progress
      const scale = this.minScale + (this.maxScale - this.minScale) * progress;

      element.style.setProperty('--scroll-zoom-scale', scale.toFixed(3));
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductHighlightScrollZoom());
  } else {
    new ProductHighlightScrollZoom();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider {
    constructor() {
      this.sections = document.querySelectorAll('[data-testimonials-section]');
      if (this.sections.length === 0) return;

      this.sections.forEach((section) => this.initSection(section));
    }

    initSection(section) {
      const slider = section.querySelector('[data-testimonials-slider]');
      const track = section.querySelector('[data-testimonials-track]');
      const dotsContainer = section.querySelector('[data-testimonials-dots]');

      if (!slider || !track) return;

      const reviews = Array.from(track.querySelectorAll('.testimonials-section__review'));
      if (reviews.length === 0) return;

      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 5000;
      const totalReviews = reviews.length;

      let currentIndex = 0;
      let autoplayInterval = null;
      let isHovering = false;

      // Create dots dynamically based on screen size
      const updateDots = () => {
        if (!dotsContainer) return;
        
        const isMobile = window.innerWidth < 750;
        const visibleReviews = this.getVisibleReviews(section);
        const totalDots = isMobile ? totalReviews : Math.ceil(totalReviews / visibleReviews);
        
        dotsContainer.innerHTML = '';
        
        for (let i = 0; i < totalDots; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `testimonials-section__dot${i === 0 ? ' testimonials-section__dot--active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.dataset.dotIndex = i;
          
          dot.addEventListener('click', () => {
            currentIndex = i;
            goToSlide(currentIndex);
            resetAutoplay();
          });
          
          dotsContainer.appendChild(dot);
        }
      };

      const goToSlide = (index) => {
        const isMobile = window.innerWidth < 750;
        const visibleReviews = this.getVisibleReviews(section);
        const reviewWidth = reviews[0].offsetWidth;
        const gap = isMobile ? 0 : 21;
        
        let offset;
        if (isMobile) {
          // On mobile: slide per single review
          offset = index * (reviewWidth + gap);
        } else {
          // On desktop: slide per page (group of visible reviews)
          offset = index * (reviewWidth + gap) * visibleReviews;
        }
        
        const maxOffset = track.scrollWidth - track.parentElement.offsetWidth;
        track.style.transform = `translateX(-${Math.min(offset, Math.max(0, maxOffset))}px)`;
        
        // Update dots
        if (dotsContainer) {
          const dots = dotsContainer.querySelectorAll('.testimonials-section__dot');
          dots.forEach((dot, i) => {
            dot.classList.toggle('testimonials-section__dot--active', i === index);
          });
        }
      };

      const nextSlide = () => {
        const isMobile = window.innerWidth < 750;
        const visibleReviews = this.getVisibleReviews(section);
        const maxIndex = isMobile ? totalReviews - 1 : Math.ceil(totalReviews / visibleReviews) - 1;
        
        currentIndex = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        goToSlide(currentIndex);
      };

      const prevSlide = () => {
        const isMobile = window.innerWidth < 750;
        const visibleReviews = this.getVisibleReviews(section);
        const maxIndex = isMobile ? totalReviews - 1 : Math.ceil(totalReviews / visibleReviews) - 1;
        
        currentIndex = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        goToSlide(currentIndex);
      };

      const startAutoplay = () => {
        if (autoplaySpeed <= 0 || isHovering) return;
        stopAutoplay();
        autoplayInterval = setInterval(nextSlide, autoplaySpeed);
      };

      const stopAutoplay = () => {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      };

      const resetAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      // Initialize dots
      updateDots();

      // Touch/swipe support
      let startX = 0;
      let isDragging = false;

      slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        stopAutoplay();
      }, { passive: true });

      slider.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;

        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;
        const threshold = 50;

        if (Math.abs(diff) > threshold) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
        
        startAutoplay();
      }, { passive: true });

      // Pause autoplay on hover (desktop)
      section.addEventListener('mouseenter', () => {
        isHovering = true;
        stopAutoplay();
      });

      section.addEventListener('mouseleave', () => {
        isHovering = false;
        startAutoplay();
      });

      // Recalculate on resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateDots();
          currentIndex = 0;
          goToSlide(currentIndex);
        }, 100);
      });

      // Start autoplay
      startAutoplay();
    }

    getVisibleReviews(section) {
      const style = getComputedStyle(section);
      const isMobile = window.innerWidth < 750;
      if (isMobile) return 1;
      return parseInt(style.getPropertyValue('--visible-reviews'), 10) || 3;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new TestimonialsSlider());
  } else {
    new TestimonialsSlider();
  }

  // Re-initialize on Shopify section events
  document.addEventListener('shopify:section:load', () => new TestimonialsSlider());

  } catch(e) { console.error(e); }
})();
})();
